import { styled } from '@slicknode/stylemapper';

export const BaseButton = styled(
  'button',
  'border-none xxs:font-normal xxs:text-left'
);
